import { type ReactNode, createContext, useContext } from "react";
import type { SubmitHandler } from "./types";

const SubmitHandlerContext = createContext<SubmitHandler<any> | undefined>(undefined);

export interface SubmitHandlerProviderProps<TDataModel> {
    onSubmit?: SubmitHandler<TDataModel>;
    children: ReactNode;
}

export const SubmitHandlerProvider = <TDataModel,>({ onSubmit, children }: SubmitHandlerProviderProps<TDataModel>) => (
    <SubmitHandlerContext.Provider value={onSubmit}>{children}</SubmitHandlerContext.Provider>
);

export const useSubmitHandler = (): SubmitHandler | undefined => useContext(SubmitHandlerContext);
